export function filterNulls<T>(
  arr: (T | null | undefined)[] | null | undefined,
): T[] {
  if (!arr) return [];
  return arr.filter((item): item is T => item !== null && item !== undefined);
}
